import { ActiveLocalAudio, AudioContext } from '@/types/audio'
import { KeyDict } from '@/types'

export const state = {
  audioContextStates: {} as KeyDict<ActiveLocalAudio>,
  activeAudioContext: AudioContext.GridPanel
}

export type AudioPanelState = typeof state
